import { PaginatedResponseType } from '../Types/Response/PaginatedResponseType';

export const PaginationPageParameters : any = {
	getPreviousPageParam: (firstPage: PaginatedResponseType) => (firstPage?.links?.previous ? `${process.env.REACT_APP_API_HOST}${firstPage.links.previous.replace('/api', '')}` : null),
	getNextPageParam: (lastPage: PaginatedResponseType) => (lastPage?.links?.next ? `${process.env.REACT_APP_API_HOST}${lastPage.links.next.replace('/api', '')}` : null),
};
